<template>
  <v-card elevation="1" class="grey lighten-4" color="grey lighten-5" height="100%">
    <v-card-text>
      <h6 class="text-h6 black--text">Escaner IA<v-chip class="ml-3" color="primary"> Nuevo </v-chip> <v-chip outlined
          class="ml-1"> Beta Version </v-chip></h6>
      <p class="text-body-2">Procesa tu comprobante con Inteligencia Artificial y carga los datos en forma automatica
      </p>
      <p class="caption">Solo admite formato PDF</p>
  
      <v-row>
        <v-col md="8">
          <v-file-input filled dense label="Seleccionar comprobante" name="invoice_file" ref="invoice_file_ref"
            v-model="invoice_file"></v-file-input>
        </v-col>
        <v-col md="4">
          <v-btn @click="readInvoice()" class="mt-3 text-white" color="blue-grey" small :loading="loading">
            Procesar</v-btn>
        </v-col>
      </v-row>

      <v-alert v-if="purchase_order != null" dense text type="info" class="mb-0">
        <small>⚠️ Al facturar desde una OC, solo se leerán: <strong>fechas, número de comprobante y tributos</strong>. Los items se mantienen desde la Orden de Compra.</small>
      </v-alert>
    </v-card-text>
  </v-card>
</template>
<script>
import { spentService } from "@/libs/ws/spentService";
import { fileUtils } from "@/libs/utils/fileUtils";
export default {
  components: { },
  props: {
    setInvoice: Function,
    open: Boolean,
    item: Object,
    purchase_order: {
      default: null,
      type: Object,
    },
  },
  data: () => ({
    invoice: null,
    invoice_file: null,
    loading: false,
    pendingBase64: null,
    pendingFileName: null,
  }),
  watch: {
    open(val) {
      if (val) {
        this.invoice_file = null;
      }
    },
  },
  mounted() { },
  methods: {
    async readInvoice() {
      if (!(this.invoice_file instanceof File)) {
        this.$toast.error("Debe seleccionar un archivo", "Error");
        return;
      }

      if (this.loading) return;

      this.loading = true;
      const b64file = await fileUtils.toBase64(this.invoice_file);

      // Guardar archivo pendiente para adjuntar solo si la validación pasa
      this.pendingBase64 = b64file;
      this.pendingFileName = this.invoice_file.name;

      // Procesar con IA
      this.procesarLectura(b64file);
    },
    async procesarLectura(b64file) {
      this.loading = true;
      spentService
        .readInvoice({ invoice_b64: b64file })
        .then((response) => {
          if (response.status) {
            // Emitir datos de IA junto con el archivo pendiente
            const dataWithFile = {
              ...response.result,
              _pendingFile: {
                base64: this.pendingBase64,
                name: this.pendingFileName
              }
            };
            this.$emit("setInvoice", dataWithFile);
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
